// Créer un groupe, créer une page — les deux fenêtres de création.
//
// Elles vivaient dans `views/groupes.js` et `views/pages.js`, dont les listes
// sont maintenant en React. Les laisser là-bas obligeait le composant React à
// importer le fichier qui l'importe : un cycle. Ici, elles ne dépendent que de
// la base et de l'interface, et les deux mondes peuvent les appeler.
//
// Elles restent en HTML à dessein : une fenêtre modale s'ouvre, se remplit, se
// ferme. Elle n'a pas d'état qui vive dans le temps, donc rien à gagner à
// passer en React — et beaucoup à perdre à y toucher sans raison.

import Store from "../store.js";
import { esc, toast, modale } from "../ui.js";
import { TYPES_GROUPE, CATEGORIES } from "../espaces-meta.js";

export function creerGroupe(apres) {
  const { el } = modale({
    titre: "Créer un groupe",
    corps: `
      <label class="label">Nom du groupe
        <input class="champ" id="g-nom" maxlength="60" placeholder="Ex : Groupe de prière du mercredi">
      </label>
      <label class="label">Type
        <div class="filtres" id="g-types">
          ${TYPES_GROUPE.map((t, i) => `<button class="chip${i === 0 ? " est-actif" : ""}" data-type="${esc(t.id)}">${t.icone} ${esc(t.label)}</button>`).join("")}
        </div>
      </label>
      <label class="label">Description
        <textarea class="champ" id="g-desc" rows="3" maxlength="400" placeholder="À qui s'adresse ce groupe, quand se retrouve-t-il…"></textarea>
      </label>
      <label class="coche"><input type="checkbox" id="g-ouvert" checked> Tout membre peut rejoindre librement</label>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Créer le groupe",
        classe: "btn--primaire",
        onClick: async (fond, fermer) => {
          const nom = fond.querySelector("#g-nom").value.trim();
          if (!nom) return toast("Donnez un nom au groupe", "erreur");
          const type = fond.querySelector("[data-type].est-actif")?.dataset.type || "autre";
          const description = fond.querySelector("#g-desc").value.trim();
          const ouvert = fond.querySelector("#g-ouvert").checked;
          fermer();
          try {
            const id = await Store.groupes.creer({ nom, type, description, image: "", ouvert });
            toast("Groupe créé 🙌");
            apres ? apres(id) : (location.hash = `#/groupe/${id}`);
          } catch (e) {
            toast(e.message || "Création impossible", "erreur");
          }
        },
      },
    ],
  });
  el.querySelector("#g-types").addEventListener("click", (e) => {
    const b = e.target.closest("[data-type]");
    if (!b) return;
    el.querySelectorAll("[data-type]").forEach((x) => x.classList.toggle("est-actif", x === b));
  });
  el.querySelector("#g-nom").focus();
}

export function creerPage(apres) {
  const { el } = modale({
    titre: "Créer une page",
    corps: `
      <p class="texte-doux petit">Une page porte la voix d'une église, d'un ministère ou d'une chorale.
      Les membres s'y abonnent ; seuls ses administrateurs y publient.</p>
      <label class="label">Nom de la page
        <input class="champ" id="p-nom" maxlength="60" placeholder="Ex : ICC Parakou">
      </label>
      <label class="label">Catégorie
        <div class="filtres" id="p-categories">
          ${CATEGORIES.map((c, i) => `<button class="chip${i === 0 ? " est-actif" : ""}" data-cat="${esc(c.id)}">${c.icone} ${esc(c.label)}</button>`).join("")}
        </div>
      </label>
      <label class="label">Description
        <textarea class="champ" id="p-desc" rows="3" maxlength="600" placeholder="Présentez la page en quelques lignes…"></textarea>
      </label>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Créer la page",
        classe: "btn--primaire",
        onClick: async (fond, fermer) => {
          const nom = fond.querySelector("#p-nom").value.trim();
          if (!nom) return toast("Donnez un nom à la page", "erreur");
          const categorie = fond.querySelector("[data-cat].est-actif")?.dataset.cat || "autre";
          const description = fond.querySelector("#p-desc").value.trim();
          fermer();
          try {
            const id = await Store.pages.creer({ nom, categorie, description, image: "", couverture: "" });
            toast("Page créée 🙌");
            apres ? apres(id) : (location.hash = `#/page/${id}`);
          } catch (e) {
            toast(e.message || "Création impossible", "erreur");
          }
        },
      },
    ],
  });
  el.querySelector("#p-categories").addEventListener("click", (e) => {
    const b = e.target.closest("[data-cat]");
    if (!b) return;
    el.querySelectorAll("[data-cat]").forEach((x) => x.classList.toggle("est-actif", x === b));
  });
  el.querySelector("#p-nom").focus();
}
